import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';
import { Field, controlBase } from './Field';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
  /** Layout for the field as a whole — grid span, width. `className` styles the textarea itself. */
  fieldClassName?: string;
}

/**
 * A multi-line field. Height comes from `rows`, so there is no size prop — a remarks box that is
 * three rows on one screen and three rows on another already matches.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, hint, className, fieldClassName, id, rows = 3, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <Field label={label} htmlFor={inputId} error={error} hint={hint} className={fieldClassName}>
        <textarea
          ref={ref}
          id={inputId}
          rows={rows}
          className={cn(controlBase(!!error), 'px-3 py-2 text-sm resize-y', className)}
          {...props}
        />
      </Field>
    );
  },
);

Textarea.displayName = 'Textarea';
